















































































































import { setCookie, getCookie } from '../utils'
import { Vue, Component } from 'vue-property-decorator'
import ffButton from '@/components/public/Button.vue'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
const appStore = namespace('app')

@Component({
  components: {
    ffButton
  }
})
export default class Home extends Vue {
  @appStore.State((state) => state.transify) private transify: any
  @appStore.State((state) => state.isLogin) private isLogin: boolean
  @appStore.State((state) => state.downloadOpen) private downloadOpen: boolean
  @appStore.State((state) => state.registerOpen) private registerOpen: boolean
  @appStore.State((state) => state.isRegister) private isRegister: boolean
  @appStore.Action('login') private login!: Function
  @appStore.Action('setUserInfo') private setUserInfo!: Function

  get benefit(): Array<object> {
    return [
      {
        title: this.transify['ADV_BENEFIT_SUBTITLE_1'] || '',
        context: this.transify['ADV_BENEFIT_SUBTITLE_1_CONTEXT'] || ''
      },
      {
        title: this.transify['ADV_BENEFIT_SUBTITLE_2'] || '',
        context: this.transify['ADV_BENEFIT_SUBTITLE_2_CONTEXT'] || ''
      },
      {
        title: this.transify['ADV_BENEFIT_SUBTITLE_3'] || '',
        context: this.transify['ADV_BENEFIT_SUBTITLE_3_CONTEXT'] || ''
      }
    ]
  }
  setBenefitIdx(idx: number): string {
    return idx < 10 ? `0${idx + 1}.` : `${idx + 1}.`
  }
  eventLogin(): void {
    this.login()
  }
  userInfo(accessToken: string): void {
    this['$http']
      .get(`/info?live_access_token=${accessToken}`)
      .then((res: any) => {
        this.setUserInfo(res.data)
        if (this.registerOpen) {
          if (!res.data.registered) {
            this['$router'].push({ path: 'register' }).catch(() => {
              return
            })
          } else {
            this['$router'].push({ path: 'download' }).catch(() => {
              return
            })
          }
        }
      })
  }
  mounted(): void {
    if (this.isLogin) {
      if (this.registerOpen) {
        if (!this.isRegister) {
          this['$router'].push({ path: 'register' }).catch(() => {
            return
          })
        } else {
          this['$router'].push({ path: 'download' }).catch(() => {
            return
          })
        }
      }
    }
    const accessToken =
      this['$route'].query['access_token'] || getCookie('liveAccessToken')
    if (this['$route'].query['access_token']) {
      setCookie('liveAccessToken', accessToken)
      this['$router'].replace('/')
    }
    if (getCookie('liveAccessToken')) {
      this.userInfo(accessToken)
    }
  }
}
